var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H12V7H11V11.5H3V3.5H7.5V2.5H5.5V0.5H4.5V2.5H3C2.73486 2.50026 2.48066 2.60571 2.29319 2.79319C2.10571 2.98066 2.00026 3.23486 2 3.5V5H0V6H2V9H0V10H2V11.5C2.00026 11.7651 2.10571 12.0193 2.29319 12.2068C2.48066 12.3943 2.73486 12.4997 3 12.5H4.5V14.5H5.5V12.5H8.5V14.5H9.5V12.5H11C11.2651 12.4996 11.5192 12.3941 11.7067 12.2067C11.8941 12.0192 11.9996 11.7651 12 11.5V10H14V9Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10H4.5V5H9.5V10ZM5.5 9H8.5V6H5.5V9Z",
    fill: "#1976D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6H13.5C13.4984 4.6744 12.9711 3.40356 12.0338 2.46622C11.0964 1.52888 9.8256 1.00159 8.5 1V0C10.0908 0.00172054 11.6159 0.634414 12.7407 1.75926C13.8656 2.88411 14.4983 4.40923 14.5 6V6Z",
    fill: "#1976D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H11C10.9992 5.3372 10.7356 4.70178 10.2669 4.23311C9.79822 3.76444 9.1628 3.50079 8.5 3.5V2.5C9.42793 2.50106 10.3176 2.87015 10.9737 3.5263C11.6299 4.18244 11.9989 5.07207 12 6Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIot);
export default __webpack_public_path__ + "static/media/iot.3a567f7061e028e3ed1e85d6b4cf0013.svg";
export { ForwardRef as ReactComponent };